// dashboard.index.tsx — T066
// Route : /dashboard — accès aux rôles ayant nationalDashboard dans la matrice.

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { usePermissions } from "@/application/hooks/usePermissions";
import { useAuth } from "@/application/contexts/AuthContext";
import { AppLayout } from "@/presentation/layouts/AppLayout";
import { DashboardNationalPage } from "@/presentation/pages/DashboardNationalPage";

export const Route = createFileRoute("/dashboard/")({
  component: function DashboardNationalComponent() {
    const { isLoading } = useAuth();
    const permissions = usePermissions();
    const navigate = useNavigate();

    useEffect(() => {
      if (!isLoading && !permissions.duerp.canViewNationalDashboard()) {
        void navigate({ to: "/" });
      }
    }, [isLoading, permissions, navigate]);

    return (
      <AppLayout>
        <DashboardNationalPage />
      </AppLayout>
    );
  },
});
